import { MessageBanner, typographyRem } from '@by-miles/bymiles-styles'
import { theme } from '@by-miles/bymiles-styles'
import React from 'react'

import { PluginTrackerOverlayStyles } from './PluginTrackerOverlayStyles'
const { paragraphBody: ParagraphBody, h2: H2, h3: H3, h5: H5 } = typographyRem

const { tints, primaryColours } = theme

export const PluginTrackerOverlay = () => {
  return (
    <PluginTrackerOverlayStyles>
      <H2 className="overlay-title">It’s easy to install.</H2>
      <div className="plugin-step-container">
        <div className="plugin-step">
          <H3 className="step">1.</H3>
          <H5>Find your socket.</H5>
        </div>
        <img className="tracker-image" src={require('../../png/tracker-plugin-1@3x.png')} alt="hello" />
        <ParagraphBody className="text">
          Your OBD-II socket is in the driver's footwell, under the steering wheel, above the pedals and towards the
          driver door, behind a small plastic cover.
        </ParagraphBody>
      </div>
      <div className="plugin-step-container">
        <div className="plugin-step">
          <H3 className="step">2.</H3>
          <H5>Plug the Miles Tracker in.</H5>
        </div>
        <img className="tracker-image" src={require('../../png/tracker-plugin-2@3x.png')} alt="hello" />
        <MessageBanner
          className="tracker-banner"
          text="90% of our members found it easy to plug in into their cars."
          backgroundColor={tints.lightAubergine}
          borderColor={primaryColours.aubergine.main}
        />
        <MessageBanner
          className="tracker-banner"
          text="It will take a matter of minutes to plug in and activate, no need to go driving."
          backgroundColor={tints.lightAubergine}
          borderColor={primaryColours.aubergine.main}
        />
      </div>
    </PluginTrackerOverlayStyles>
  )
}
